import { useState } from "react"
import styled from "styled-components"
import { Box, Grid, Typography } from "@material-ui/core"
import { bps } from "theme"
import React from "react"
import data from "data/play/start-playing"
import Lottie from "react-lottie"
import Carousel from "nuka-carousel"
import TriangleImage from "resources/assets/triangle.svg"
import animationData from "resources/animations/data.json"

const StyledAnimation = styled.div`
  position: relative;

  .animation {
    position: relative;
  }

  @-moz-document url-prefix() {
    .triangle {
      position: absolute;
      bottom: -116px !important;
      left: -138px !important;
      right: 0;
      width: 600px !important;
    }
  }
  .triangle {
    position: absolute;
    bottom: -105px;
    left: 0;
    width: 100%;
  }
`

const Animation = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
  }
  return (
    <StyledAnimation>
      <img
        className="triangle"
        src={TriangleImage}
        loading="lazy"
        alt="yellow triangle"
      ></img>
      <Lottie options={defaultOptions} height={600} />
    </StyledAnimation>
  )
}

const StyledContainer = styled.div`
  background-color: #fbfaff;
`

const StyledDiv = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 96px 16px 88px 16px;

  color: #000;

  .number {
    border-radius: 50%;
    width: 60px;
    height: 60px;
    border: 3px solid #0cb775;
    padding-top: 14px;
    margin-top: 8px;
  }

  .activeNumber {
    color: #fff;
    background-color: #0cb775;
    transition: 1s;
  }
  .inactiveNumber {
    color: #0cb775;
  }

  ${bps.down("md")} {
    .grid-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
    }
  }
`

const DesktopStartPlaying = () => {
  const [getSelectedStep, setSelectedStep] = useState(1)
  const intervals = [0, 4166, 10450, 19540, 10750]
  const onStepsClicked = (step: React.SetStateAction<number>) => {
    if (getSelectedStep !== step) {
      setSelectedStep(step)
    }
  }

  const items = [
    <span key={1}></span>,
    <span key={2}></span>,
    <span key={3}></span>,
  ]

  return (
    <StyledContainer>
      <StyledDiv>
        <Grid
          container
          justify="center"
          alignItems="center"
          className="grid-container"
          spacing={6}
        >
          <Grid item xs md={6}>
            <Grid container justify="center" alignItems="flex-end">
              <Animation />
              <Carousel
                pauseOnHover={false}
                autoplay={true}
                withoutControls={true}
                wrapAround={true}
                swiping={false}
                autoplayInterval={intervals[getSelectedStep]}
                dragging={false}
                speed={1}
                beforeSlide={slideIndex => {
                  let switchItem = 1
                  if (slideIndex === 0) {
                    switchItem = 2
                  } else if (slideIndex === 1) {
                    switchItem = 3
                  } else if (slideIndex === 2) {
                    switchItem = 4
                  } else if (slideIndex === 3) {
                    switchItem = 1
                  }
                  onStepsClicked(switchItem)
                }}
              >
                {items}
              </Carousel>
            </Grid>
          </Grid>

          <Grid item xs md={6}>
            <Typography variant="h2">EASY TO START PLAYING</Typography>
            <Box my={6} />

            <Grid
              container
              direction="column"
              justify="center"
              alignItems="center"
            >
              {data.easyToStartPlayingData.map((item: any, index: number) => (
                <>
                  <div
                    className={
                      getSelectedStep === index + 1 ? "active" : "inactive"
                    }
                  >
                    <Grid container className="grid-container" spacing={6}>
                      <Grid item xs>
                        <Typography
                          align="center"
                          variant="h3"
                          className={
                            getSelectedStep === index + 1
                              ? "activeNumber number"
                              : "inactiveNumber number"
                          }
                        >
                          {index + 1}
                        </Typography>
                      </Grid>
                      <Grid item xs={10}>
                        <Typography variant="h3">{item.title}</Typography>
                        <Box mt={1} />
                        <Typography variant="h6">{item.description}</Typography>
                      </Grid>
                    </Grid>
                  </div>
                  {index != 3 && <Box mt={4} />}
                </>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </StyledDiv>
    </StyledContainer>
  )
}

export default DesktopStartPlaying
